<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton.mr-2(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getGameResult(true)"
          variant="primary"
          size="sm"
        )
        jsonToExcel(v-if="gameResultList.length > 0" mode="PendingBetList9W" tbl="tblPendingBetList9W" :date="dateRange")
        pendingBetList9WExport(v-if="gameResultList.length > 0" :tbl="gameResultList" :totalTbl="grandTotalList" tblId="tblPendingBetList9W")
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-resizable#tblPendingBetList9W(style="width:100%;" v-if="displayTable")
            thead.thead-light(v-columns-resizable)
              tr
                th.text-center.sticky-position(width="3%")
                  span #
                th.sticky-position.sortable(width="12%" @click="sortOrder('bet_time')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.date_time')") {{ $t('ui.date_time') }}
                    i(:class="changeSortKey('bet_time')")
                th.sticky-position(width="10%")
                  span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                th.sticky-position.sortable(width="10%")
                  span(:title="$t('ui.sports_game')") {{ $t('ui.sports_game') }}
                th.sticky-position.sortable(width="15%")
                  span(:title="$t('ui.event')") {{ $t('ui.event') }}
                th.sticky-position.sortable(width="10%")
                  span(:title="$t('ui.detail')") {{ $t('ui.detail') }}
                th.sticky-position.text-right(width="10%" @click="sortOrder('bet_amount')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.bet_amount')") {{ $t('ui.bet_amount') }}
                    i(:class="changeSortKey('bet_amount')")
                th.sticky-position.text-right(width="10%" @click="sortOrder('actual_bet_amount')")
                  .d-flex.justify-content-between.align-items-center
                    span(:title="$t('ui.actual_bet_amount')") {{ $t('ui.actual_bet_amount') }}
                    i(:class="changeSortKey('actual_bet_amount')")
            tbody.clusterize-content
              tr(v-if="gameResultList.length == 0")
                td(colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              template(v-for="(item, index) in gameResultList")
                tr
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="$moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.bet_time).format('YYYY-MM-DD, HH:mm:ss') }}
                    br
                    span.font-weight-bold(:title="item.bet_id") {{ item.bet_id }}
                    br
                    span(:title="item.ip") {{ item.ip }}
                  td
                    span(:title="item.member_id") {{ item.member_id }}&nbsp;
                  td
                    //- span(:title="item.sports_type") {{ item.sports_type }}
                    //- br
                    span(:title="item.sports_category") {{ item.sports_category }}&nbsp;
                    br
                    span(:title="item.game_type_name") {{ item.game_type_name }}&nbsp;
                  td
                    template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
                      small {{  item.provider_code }}
                      template(v-if="item.bet_type != 'PARLAY'")
                        span.font-weight-bold(:title="item.league_name") {{ item.league_name }}&nbsp;
                        br
                        template(v-if="item.game_type_name")
                          span.text-success(:title="item.game_type_name") {{ item.game_type_name.split(" v ")[0] }}&nbsp;
                          template(v-if="item.game_type_name.split(' v ')[1] != null")
                            span vs 
                            span.text-danger(:title="item.game_type_name") {{ item.game_type_name.split(" v ")[1] }}&nbsp;
                      template(v-else)
                        span.font-weight-bold(:title="$t('ui.mix_parlay')") {{ $t("ui.mix_parlay") }}
                        br
                        span(:title="item.odds_display_bet") {{ item.odds_display_bet }}&nbsp;                      
                  td
                    template(v-if="!['IB','CM','S3'].includes(item.provider_code)")
                      span(:title="item.bet_type") {{ item.bet_type }}&nbsp;
                      br
                      span(:title="item.bet_hand") {{ item.bet_hand }}&nbsp;
                      br
                      span(v-if="item.odds_display != null" :title="item.odds_display + ' ' + getOddsType(item.odds_type)") {{ item.odds_display + ' ' + getOddsType(item.odds_type) }}&nbsp;
                    template(v-else)
                      i.fas.fa-comment-dots.text-primary(
                        role="button"
                        :title="$t('ui.remark')"
                        style="cursor: pointer;"
                        @click="openRemarkModal(item.remark, item.provider_code)"
                      )
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.bet_amount)" :title="$n(item.bet_amount, 'currency')") {{ $n(item.bet_amount, 'currency') }}
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.actual_bet_amount)" :title="$n(item.actual_bet_amount, 'currency')") {{ $n(item.actual_bet_amount, 'currency') }}
                  //- td.text-center
                  //-   i.fa.ml-1(size="sm" @click="onOffDetail(item)" :class="currId == item.result_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                //- tr(v-if="isShowDetail == true && currId == item.result_id")
                //-   td(colspan="10")
                //-     table.tablex(style="width: 100%;")
                //-       thead
                //-         tr
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.match_time')") {{ $t("ui.match_time") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.league_name')") {{ $t("ui.league_name") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.home_team_name')") {{ $t("ui.home_team_name") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.away_team_name')") {{ $t("ui.away_team_name") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.home_score')") {{ $t("ui.home_score") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.away_score')") {{ $t("ui.away_score") }}
                //-           th.sticky-position.text-center(width="3%")
                //-             span(:title="$t('ui.wl_status')") {{ $t("ui.wl_status") }}
                //-       tbody.clusterize-content
                //-         td
                //-           span(:title="$moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.match_time).format('YYYY-MM-DD, HH:mm:ss') }}
                //-         td
                //-           span(:title="item.league_name") {{ item.league_name }}
                //-         td.text-center
                //-           span(:title="item.home_team_name") {{ item.home_team_name }}
                //-         td.text-center
                //-           span(:title="item.away_team_name") {{ item.away_team_name }}
                //-         td.text-center
                //-           span(:title="item.home_score") {{ item.home_score }}
                //-         td.text-center
                //-           span(:title="item.away_score") {{ item.away_score }}
                //-         td.text-center
                //-           span(:title="item.wl_status") {{ item.wl_status }}
              tr(v-if="showTotal")
                td.text-right(colspan="6")
                  span {{ $t("ui.sub_total") }}
                  br
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalBetAmount)" :title="$n(subTotalBetAmount, 'currency')") {{ $n(subTotalBetAmount, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBetAmount)" :title="$n(grandTotalBetAmount, 'currency')") {{ $n(grandTotalBetAmount, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalActualBetAmount)" :title="$n(subTotalActualBetAmount, 'currency')") {{ $n(subTotalActualBetAmount, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalActualBetAmount)" :title="$n(grandTotalActualBetAmount, 'currency')") {{ $n(grandTotalActualBetAmount, 'currency') }}
                //- td
                //- td
              //- td
    b-modal#remarkModal(
      ref="remarkModal"
      :title="$t('ui.remark')"
      hide-footer
      centered
      no-fade
      @hidden="resetRemarkModal"
    )
      //- template(v-if="selectedRemarkParts.length")
      //-   p.mb-0.text-break(
      //-     v-for="(remarkLine, idx) in selectedRemarkParts"
      //-     :key="idx"
      //-     style="white-space: pre-line;"
      //-   ) {{ remarkLine }}
      template(v-if="selectedRemark")
        p.mb-0.text-break(style="white-space: pre-line;") {{ selectedRemark }}
      template(v-else)
        p.mb-0.text-break {{ $t('message.no_data_available') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import jsonToExcel from "@/library/jsonToExcel.vue";
import pendingBetList9WExport from "@/components/report/pendingBetList9WExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    jsonToExcel,
    pendingBetList9WExport
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    gameResultList: [],
    currentPage: 1,
    totalRow: 0,
    subTotalBetAmount: 0,
    grandTotalBetAmount: 0,
    subTotalActualBetAmount: 0,
    grandTotalActualBetAmount: 0,
    showTotal: false,
    selectedRemark: '',
    selectedRemarkParts: [],
    selectedProviderCode: '',
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "bet_time",
    sortType: "desc",
    currId: null,
    isShowDetail: false,
    displayTable: false,
    dateRange: {
      startDate: null,
      endDate: null,
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberReport;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
  },
  mounted: function() {  },
  destroyed: function() {},
  methods: {
    refresh() {
      this.displayTable = false;
      this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD 00:00:00');
      this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD 23:59:59');

      this.getGameResult(true);

      setTimeout(() => {
        this.displayTable = true;
      }, 10);
    },
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.result_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.result_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.result_id;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getGameResult(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    // getResultDetail(e) {
    //   window.open(config.gameResultDetailUrl + e, "info", "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640");
    // },
    getOddsType(n) {
      var result = "";
      switch(n) {
        case 1:
          result = "(MY)";
          break;
        case 2:
          result = "(HK)";
          break;
        case 3:
          result = "(ID)";
          break;
        case 4:
          result = "(DEC)";
          break;
      }
      return result;
    },
    getGameResult: function(isSearch) {
      let url = config.pendingBetList9WUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.memberID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.clearTotal()
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.total.length > 0) {
                  this.showTotal = true
                  response.data.ds.total.forEach(value => {
                    this.subTotalBetAmount = parseFloat(this.subTotalBetAmount) + parseFloat(value["bet_amount"]);
                    this.subTotalActualBetAmount = parseFloat(this.subTotalActualBetAmount) + parseFloat(value["actual_bet_amount"]);
                  });

                  if(response.data.ds.grand_total.length > 0) {
                    this.grandTotalBetAmount = response.data.ds.grand_total[0]["bet_amount"];
                    this.grandTotalActualBetAmount = response.data.ds.grand_total[0]["actual_bet_amount"];
                  }

                  this.grandTotalList = response.data.ds.grand_total
                  this.gameResultList = response.data.ds.total;
                  this.totalRow = response.data.ds.total.length > 0 ? this.gameResultList[0]["totalrows"] : 0
                } else {
                  this.clearTotal()
                }
              } else {
                this.clearTotal()
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    clearTotal() {
      this.showTotal = false;
      this.gameResultList = []
      this.totalRow = 0
      this.subTotalBetAmount = 0
      this.grandTotalBetAmount = 0
      this.subTotalActualBetAmount = 0
      this.grandTotalActualBetAmount = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalPayout = 0
      this.grandTotalPayout = 0
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'pendingbetlist9w') return
      this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
      this.currentPage = 1;
      this.getGameResult(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getGameResult();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    openRemarkModal(remark, providerCode) {
      this.selectedProviderCode = providerCode || '';
      this.selectedRemark = remark || '';
      this.selectedRemarkParts = this.buildRemarkParts(this.selectedRemark, this.selectedProviderCode);
      if (this.$refs.remarkModal) {
        this.$refs.remarkModal.show();
      }
    },
    resetRemarkModal() {
      this.selectedRemark = '';
      this.selectedRemarkParts = [];
      this.selectedProviderCode = '';
    },
    buildRemarkParts(remark, providerCode) {
      if (!remark) return [];

      const delimiterMap = {
        S3: '|',
        CM: ',',
        IB: '-'
      };

      const delimiter = delimiterMap[(providerCode || '').toUpperCase()];

      if (!delimiter) return [remark];

      return remark
        .split(delimiter)
        .map(value => value.trim())
        .filter(value => value.length > 0);
    }
  }
};
</script>
